import { MaterialCiqIcon, ScheduleCiqIcon } from "components/svg-icons";
import { useMemo } from "react";
import { BidPackageTileCiqIcon } from "./bid-package-ciq-icon";
import { ConstructionTileCiqIcon } from "./construction-ciq-icon";
import { DesignPackageTileCiqIcon } from "./design-package-ciq-icon";
import { DesignScopeTileCiqIcon } from "./design-scope-ciq-icon";
import { MaterialTileCiqIcon } from "./material-ciq-icon";
import { PreconTileCiqIcon } from "./precon-ciq-icon";
import ProjectLogoIcon from "./project-logo";
import { ScheduleTileCiqIcon } from "./schedule-ciq-icon";
import SubmittalLogCiqIcon from "./submittal-log-ciq-icon";
import SubmittalUntrackedCiqIcon from "./submittal-untracked-ciq-icon";
import SubmittalVoidedDeletedCiqIcon from "./submittal-voided-deleted-ciq-icon";

function CiqIconBox({
  feature,
  size = 12,
  padding = 4
}: {
  size?: number;
  padding?: number;
  feature:
    | "MATERIALS"
    | "SUBMITTALS"
    | "DESIGN_PACKAGE"
    | "DESIGN_SCOPE"
    | "BID_PACKAGE"
    | "PRECON"
    | "CONSTRUCTION"
    | "PROJECT_DASHBOARD"
    | "SCHEDULES"
    | "SCHEDULES_OPC"
    | "EXTRACTED_MATERIALS"
    | "SUBMITTALS_UNTRACKED"
    | "SUBMITTALS_VOIDED"
    | "SUBMITTALS_DELETED";
}) {
  const getInfo = useMemo(() => {
    const badgeSize = size + padding * 2;

    switch (feature) {
      // Module badges carry their own tile (the *TileCiqIcon exports), so
      // they fill the whole badge with no box padding.
      case "MATERIALS":
        return {
          icon: <MaterialTileCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "EXTRACTED_MATERIALS":
        return {
          icon: (
            <MaterialCiqIcon
              size={size}
              className="fill-[#722ED1]"
              opacity="1"
            />
          ),
          color: "var(--ciq-golden-purple-100)",
          additionalClassName:
            "border-ciq-golden-purple-400 border border-solid"
        };
      case "SUBMITTALS":
        return {
          icon: <SubmittalLogCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "SCHEDULES":
        return {
          icon: <ScheduleTileCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      // Schedules sourced from OPC get the brand vermillion with a knocked-out
      // white glyph, rather than the light-fill/dark-glyph treatment the
      // in-CIQ schedule pages use.
      case "SCHEDULES_OPC":
        return {
          icon: (
            <ScheduleCiqIcon size={size} className="fill-white" opacity="1" />
          ),
          color: "var(--ciq-red-brand)",
          additionalClassName: ""
        };
      case "BID_PACKAGE":
        return {
          icon: <BidPackageTileCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "DESIGN_PACKAGE":
        return {
          icon: <DesignPackageTileCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "DESIGN_SCOPE":
        return {
          icon: <DesignScopeTileCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "CONSTRUCTION":
        return {
          icon: <ConstructionTileCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "PRECON":
        return {
          icon: <PreconTileCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "PROJECT_DASHBOARD":
        return {
          icon: <ProjectLogoIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "SUBMITTALS_UNTRACKED":
        return {
          icon: <SubmittalUntrackedCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      case "SUBMITTALS_VOIDED":
      case "SUBMITTALS_DELETED":
        return {
          icon: <SubmittalVoidedDeletedCiqIcon size={badgeSize} />,
          color: "transparent",
          additionalClassName: "",
          padding: 0
        };
      default:
        break;
    }
    return { icon: null, color: "white", additionalClassName: "" };
  }, [feature, size, padding]);

  const boxPadding =
    "padding" in getInfo && typeof getInfo.padding === "number"
      ? getInfo.padding
      : padding;

  return (
    <div
      className={`flex items-center justify-center rounded ${getInfo.additionalClassName}`}
      style={{ padding: boxPadding, backgroundColor: getInfo.color }}
    >
      {getInfo.icon}
    </div>
  );
}
export default CiqIconBox;
